import React from "react";
import Head from "next/head";

import ArticleMain from "@/components/help/article-main";
import {
  articleMapping,
  categoryMapping,
  collections,
} from "@/components/help/help-articles-data";
import { ArticleKeys, CategoryKeys } from "@/@types/help/Articles";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { helpArticlePaths } from "@/utils/help-paths";

const HelpArticlePage = ({ collection, category, article }: any) => {
  return (
    <>
      <Head>
        <title>{seoData.HELP_CENTER.title}</title>
        <SeoMetaData data={seoData.HELP_CENTER} />
      </Head>

      <ArticleMain
        collection={collections.find((c) => c.link === collection) as any}
        category={
          {
            key: category,
            value: categoryMapping[category as CategoryKeys],
          } as any
        }
        article={
          {
            key: article,
            value: articleMapping[article as ArticleKeys],
          } as any
        }
      />
    </>
  );
};

// Enumerate every collection/category/article triple from local data. The old
// getServerSideProps was a param-passthrough (not a real SSR dependency); the
// full path set is built here so output:"export" can prerender every article.
export async function getStaticPaths() {
  const paths = helpArticlePaths.map(({ collection, category, article }) => ({
    params: { collection, category, article },
  }));
  return { paths, fallback: false };
}

export async function getStaticProps({ params }: any) {
  const { collection, category, article } = params;
  return { props: { collection, category, article } };
}

export default HelpArticlePage;
